import React from "react";
import PropTypes from "prop-types";
// import Grid from '@material-ui/core/Grid'
import { makeStyles } from "@material-ui/core/styles";
import gomunityLogo from "./assets/gomunity_logo.png";
// import SquareBox from 'components/SquareBox'

const useStyles = makeStyles({
  image: {
    width: "180px",
    height: "auto",
    maxHeight: "96px",
    objectFit: "contain",
  },
  wrapper: {
    position: "relative",
    zIndex: 1,
    display: "flex",
    alignItems: "stretch",
    flexWrap: "wrap",
    width: "100%",
    borderRadius: "1rem",
    background: "#f3f6f9",
    border: "1px solid #f1f5f9",
    boxShadow:
      "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
    overflow: "hidden",
  },
  imageContainer: {
    padding: "24px",
    background: "linear-gradient(160deg, #fbf7ef 0%, #f2e9d7 100%)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    "@media (max-width: 768px)": {
      display: "none",
    },
  },
  mainContainer: {
    padding: "24px",
    flex: 1,
    background: "#ffffff",
  },
});

function MembershipBox({ children }) {
  const classes = useStyles();

  return (
    <div className="member-animated-border">
      <div className={classes.wrapper}>
        <div className={classes.imageContainer}>
          <img alt="Gomunity" className={classes.image} src={gomunityLogo} />
        </div>
        <div className={classes.mainContainer}>{children}</div>
      </div>
    </div>
  );
}

MembershipBox.propTypes = {
  children: PropTypes.node.isRequired,
};

export default MembershipBox;
